import { getAuth } from "firebase/auth";

// returns null if the user is not logged in
export function useUserId(){
    const auth = getAuth();

    // be really careful!
    return auth?.currentUser?.uid
}